module.exports = __webpack_public_path__ + "img/fix.43ee8d0f.svg";